import { DEFAULT_CONNECTION_CREATION } from '../../../../draw/connectionCreationDefaults.js'
import { DEFAULT_CONNECTION_DATA } from '../../../../draw/connectionData.js'
import { PRESS_EVENTS } from '../shared.js'

export const connection = {
    parts: {},
    properties: {
        // Structural / geometric — the Designer owns routing and geometry, so
        // these are deliberately NOT runtime-writable (no `runtime` block).
        from: { type: 'string', label: 'From' },
        to: { type: 'string', label: 'To' },
        from_side: { type: 'enum', values: ['auto', 'top', 'right', 'bottom', 'left'], label: 'From side' },
        to_side: { type: 'enum', values: ['auto', 'top', 'right', 'bottom', 'left'], label: 'To side' },
        // Authoring semantics: which endpoint supplies `value`. Design-time only.
        value_source: { type: 'enum', values: ['own', 'from', 'to'], label: 'Value source' },

        // Visual / data / animation — runtime transports (HA plugin, MQTT,
        // native API) may write these. See properties/v2/runtime.js.
        corner_radius: { type: 'int', min: 0, label: 'Corner radius', runtime: { writable: true } },
        line_width: { type: 'int', min: 1, label: 'Line width', runtime: { writable: true } },
        line_color: { type: 'color', format: 'hex8', label: 'Line color', runtime: { writable: true } },
        min: { type: 'int', label: 'Minimum', runtime: { writable: true } },
        max: { type: 'int', label: 'Maximum', runtime: { writable: true } },
        // `value` travels to the plate as `val` — an existing wire name, not a new alias.
        value: { type: 'int', label: 'Value', runtime: { writable: true, wireName: 'val' } },
        animation_enabled: { type: 'bool', label: 'Animation enabled', runtime: { writable: true } },
        bullet_color: { type: 'color', format: 'hex8', label: 'Bullet color', runtime: { writable: true } },
        bullet_size: { type: 'int', min: 1, label: 'Bullet size', runtime: { writable: true } },
        bullet_count: { type: 'int', min: 1, label: 'Bullet count', runtime: { writable: true } },
    },
    defaults: {
        properties: {
            from: '', to: '', from_side: 'auto', to_side: 'auto',
            corner_radius: DEFAULT_CONNECTION_CREATION.corner_radius,
            line_width: DEFAULT_CONNECTION_CREATION.line_width,
            line_color: '#ffffffff',
            ...DEFAULT_CONNECTION_DATA,
            animation_enabled: DEFAULT_CONNECTION_CREATION.animation_enabled,
            bullet_color: '#ffffffff',
            bullet_size: DEFAULT_CONNECTION_CREATION.bullet_size,
            bullet_count: DEFAULT_CONNECTION_CREATION.bullet_count,
        },
        styles: {},
    },
    states: [],
    editorCapabilities: ['no_geom'],
    runtimeCapabilities: [],
    events: PRESS_EVENTS,
    // Runtime-writable properties are derived from `runtime.writable` above —
    // `bindings.properties` only carries per-property strategy overrides now.
    bindings: { properties: {}, actions: { hass_services: [] }, events: {} },
}
